/**
 * @generated SignedSource<<668fbf06820fa5f9f621813a86fd792f>>
 * @relayHash 9ea995599d5a28724f789a13cffad87f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84a5bf8db4d5733b55ab8be4a9bac682b89dc1e3f8ab6e56f5369a3137e6aa15

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraFieldSetPreferencesMutationInput = {
  nodes?: ReadonlyArray<JiraUpdateFieldSetPreferencesInput> | null | undefined;
};
export type JiraUpdateFieldSetPreferencesInput = {
  fieldSetId: string;
  width?: number | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type main_updateFieldSetPreferencesMutation$variables = {
  cloudId: string;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  input: JiraFieldSetPreferencesMutationInput;
  viewId?: string | null | undefined;
};
export type main_updateFieldSetPreferencesMutation$data = {
  readonly jira: {
    readonly updateUserFieldSetPreferences: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type main_updateFieldSetPreferencesMutation = {
  response: main_updateFieldSetPreferencesMutation$data;
  variables: main_updateFieldSetPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v4 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
          },
          {
            "kind": "Variable",
            "name": "fieldSetPreferencesInput",
            "variableName": "input"
          },
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "concreteType": "JiraFieldSetPreferencesUpdatePayload",
        "kind": "LinkedField",
        "name": "updateUserFieldSetPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_updateFieldSetPreferencesMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_updateFieldSetPreferencesMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "84a5bf8db4d5733b55ab8be4a9bac682b89dc1e3f8ab6e56f5369a3137e6aa15",
    "metadata": {},
    "name": "main_updateFieldSetPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a01e3ed61486b0d7d7faf04b338c4960";

export default node;
